import React from 'react';
import { cn } from '../../lib/cn';
import { BrandLogo } from '../BrandLogo/BrandLogo';
import { Spinner } from '../Spinner/Spinner';

export interface ElvaPageLoaderProps {
  className?: string;
  logoSrc?: string;
}

export function ElvaPageLoader({ className, logoSrc = '/logo.svg' }: ElvaPageLoaderProps) {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 flex-col items-center justify-center gap-4 py-16',
        className,
      )}
    >
      <BrandLogo src={logoSrc} alt="Elva" className="h-10 w-10" />
      <Spinner size={20} />
    </div>
  );
}
